export const cashSessionStatusValues = ['open', 'closed'] as const;
export type CashSessionStatus = (typeof cashSessionStatusValues)[number];

export const cashOpeningModeValues = ['accepted', 'verified'] as const;
export type CashOpeningMode = (typeof cashOpeningModeValues)[number];

export const cashSessionCloseModeValues = ['normal', 'forceCounted', 'forceUnverified'] as const;
export type CashSessionCloseMode = (typeof cashSessionCloseModeValues)[number];

export const cashForceCloseModeValues = ['counted', 'unverified'] as const;
export type CashForceCloseMode = (typeof cashForceCloseModeValues)[number];

// Monetary amounts are in minor units (e.g., cents).
export interface CashDenominationDto {
  denom: number;
  count: number;
}

// Monetary amounts are in minor units (e.g., cents).
export interface CashSessionDto {
  id: string;
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  cashLocationId: string;
  status: CashSessionStatus;
  openedAt: string;
  closedAt: string | null;
  openedByUserId: string;
  closedByUserId: string | null;
  openingLedgerBalanceMinor: number | null;
  openingMode: CashOpeningMode;
  openingBasisAmountMinor: number;
  openingCountedAmountMinor: number | null;
  openingCountDenominations?: CashDenominationDto[] | null;
  currentExpectedCashMinor: number | null;
  closeMode: CashSessionCloseMode | null;
  closeExpectedCashMinor: number | null;
  closeCountedCashMinor: number | null;
  closeVarianceAmountMinor: number | null;
  openingNote: string | null;
  closingNote: string | null;
  closingDenominations?: CashDenominationDto[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface OpenCashSessionRequest {
  companyId: string;
  operationId: string;
  occurredAt?: string;
  stationId: string;
  storeId?: string;
  locationId?: string;
  cashLocationId: string;
  openingMode?: CashOpeningMode;
  openingCountedAmountMinor?: number | null;
  openingCountDenominations?: CashDenominationDto[] | null;
  openingNote?: string | null;
}

export interface OpenCashSessionResponse {
  cashSession: CashSessionDto;
}

export interface CloseCashSessionRequest {
  companyId: string;
  operationId: string;
  occurredAt?: string;
  cashSessionId: string;
  stationId: string;
  storeId?: string;
  locationId?: string;
  countedCashMinor: number;
  closingNote?: string | null;
  denominations?: CashDenominationDto[] | null;
}

export interface CloseCashSessionResponse {
  cashSession: CashSessionDto;
}

export interface ForceCloseCashSessionRequest {
  companyId: string;
  operationId: string;
  occurredAt?: string;
  cashSessionId: string;
  stationId: string;
  storeId?: string;
  locationId?: string;
  mode: CashForceCloseMode;
  reasonNote: string;
  countedCashMinor?: number | null;
  denominations?: CashDenominationDto[] | null;
}

export interface ForceCloseCashSessionResponse {
  cashSession: CashSessionDto;
}

export interface GetCurrentCashSessionRequest {
  companyId: string;
  stationId: string;
  storeId?: string;
  locationId?: string;
  cashLocationId: string;
}

export interface GetCurrentCashSessionResponse {
  cashSession: CashSessionDto | null;
}

export interface ListCashSessionsRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  status?: CashSessionStatus;
  from?: string;
  to?: string;
}

export interface ListCashSessionsResponse {
  items: CashSessionDto[];
}
